import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject;
import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { remCalc } from '@lux/helpers';
import Anchor from '../Anchor';
import Grid from '../Grid';
import Column from '../Column';
import Row from '../Row';
import Theme from '../../theme';
import Search from './Search';
import Logo from './Logo';
import IconClose from '../../assets/svgs/close.svg';
import IconChevronUp from '../../assets/svgs/chevron-up.svg';
import IconChevronDown from '../../assets/svgs/chevron-down.svg';
import IconMenuBack from '../../assets/svgs/chevron-left.svg';
export var SCHamburgerMenu = styled.div.withConfig({
  displayName: "MobileMenu__SCHamburgerMenu",
  componentId: "sc-1g4uqsk-0"
})(["height:100vh;position:fixed;top:0;left:0;right:0;background-color:", ";border-top:4px solid ", ";opacity:0;overflow-y:auto;visibility:hidden;z-index:99999;transition:all 400ms ease-out;transform:translate(-200px,0);", ";", ";"], function (props) {
  return props.theme === 'dark' ? Theme.colours.darkslate : Theme.colours.white;
}, Theme.colours.singtelred, function (props) {
  return props.isHamburgerMenuOpen && css(["transform:translate(0,0);opacity:1;visibility:visible;"]);
}, Theme.media.lg(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  transform: translate(-100vw, 0);\n  "]))));
var SCHamburgerHeader = styled(Row).withConfig({
  displayName: "MobileMenu__SCHamburgerHeader",
  componentId: "sc-1g4uqsk-1"
})(["height:64px;"]);
var SCMenuCloseIcon = styled(IconClose).withConfig({
  displayName: "MobileMenu__SCMenuCloseIcon",
  componentId: "sc-1g4uqsk-2"
})(["cursor:pointer;float:right;& path{fill:", ";}"], function (props) {
  return props.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
});
var SCMenuIconChevronUp = styled(IconChevronUp).withConfig({
  displayName: "MobileMenu__SCMenuIconChevronUp",
  componentId: "sc-1g4uqsk-3"
})(["path{fill:", ";}"], function (props) {
  return props.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
});
var SCMenuIconChevronDown = styled(IconChevronDown).withConfig({
  displayName: "MobileMenu__SCMenuIconChevronDown",
  componentId: "sc-1g4uqsk-4"
})(["path{fill:", ";}"], function (props) {
  return props.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
});
var StyledSearchContainer = styled.div.withConfig({
  displayName: "MobileMenu__StyledSearchContainer",
  componentId: "sc-1g4uqsk-5"
})(["margin-bottom:", ";"], remCalc(16));
var SCColumnPrimaryMenuItem = styled(Column).withConfig({
  displayName: "MobileMenu__SCColumnPrimaryMenuItem",
  componentId: "sc-1g4uqsk-6"
})(["padding:0 ", ";"], remCalc(8));
var SCColumnSubMenuItem = styled(SCColumnPrimaryMenuItem).withConfig({
  displayName: "MobileMenu__SCColumnSubMenuItem",
  componentId: "sc-1g4uqsk-7"
})(["padding-left:", ";"], remCalc(8));
var SCAnchorBlack = styled(Anchor).withConfig({
  displayName: "MobileMenu__SCAnchorBlack",
  componentId: "sc-1g4uqsk-8"
})(["color:", ";font-size:", ";display:block;&:not([disabled]){&:hover{color:", ";}}", ";& svg{float:right;}"], function (props) {
  return props.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
}, Theme.fonts.sizes.small, function (props) {
  return props.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
}, function (props) {
  return props.active && css(["color:", ";&:not([disabled]){&:hover{color:", ";}}"], Theme.colours.singtelred, Theme.colours.singtelred);
});
var SCColumnSubSubMenuItem = styled(Column).withConfig({
  displayName: "MobileMenu__SCColumnSubSubMenuItem",
  componentId: "sc-1g4uqsk-9"
})(["margin-top:", ";padding-left:", ";"], remCalc(8), remCalc(32));
var Divider = styled.div.withConfig({
  displayName: "MobileMenu__Divider",
  componentId: "sc-1g4uqsk-10"
})(["margin:", " ", ";border-bottom:1px solid ", ";"], remCalc(16), remCalc(-16), Theme.colours.grey_e2);
var StyledFourthLevelMenuColumn = styled(Column).withConfig({
  displayName: "MobileMenu__StyledFourthLevelMenuColumn",
  componentId: "sc-1g4uqsk-11"
})(["padding-left:", ";"], remCalc(32));
var StyledIconColumn = styled(Column).withConfig({
  displayName: "MobileMenu__StyledIconColumn",
  componentId: "sc-1g4uqsk-12"
})(["height:", ";"], remCalc(16));
var StyledIconMenuBack = styled(IconMenuBack).withConfig({
  displayName: "MobileMenu__StyledIconMenuBack",
  componentId: "sc-1g4uqsk-13"
})(["vertical-align:middle;"]);
var Menu = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Menu, _React$Component);
  function Menu(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.onThirdLevelMenuClick = function (menu) {
      _this.setState({
        thirdLevelMenu: menu
      });
      _this.props.onThirdLevelMenuClick();
    };
    _this.state = {
      thirdLevelMenu: {
        subMenu: []
      }
    };
    return _this;
  }
  var _proto = Menu.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      baseUrl = _this$props.baseUrl,
      menuItems = _this$props.menuItems,
      activeSubMenuItem = _this$props.activeSubMenuItem,
      activeMenuItem = _this$props.activeMenuItem,
      onMenuItemClick = _this$props.onMenuItemClick,
      firstLevelLinks = _this$props.firstLevelLinks,
      isFourthLevelMenuOpen = _this$props.isFourthLevelMenuOpen,
      theme = _this$props.theme;
    var thirdLevelMenu = this.state.thirdLevelMenu;
    return isFourthLevelMenuOpen ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(SCAnchorBlack, {
      "data-testid": "MMAnchorBlack",
      href: "" + baseUrl + thirdLevelMenu.item.href,
      theme: theme
    }, thirdLevelMenu.item.title), /*#__PURE__*/React.createElement(Divider, null), (thirdLevelMenu.subMenu || []).map(function (menuItem, menuKey) {
      return /*#__PURE__*/React.createElement(Fragment, {
        key: menuKey
      }, /*#__PURE__*/React.createElement(Row, {
        key: menuKey,
        middle: "sm"
      }, /*#__PURE__*/React.createElement(StyledFourthLevelMenuColumn, {
        sm: 12,
        "data-testid": "MMFourthLevelMenuColumn"
      }, /*#__PURE__*/React.createElement(SCAnchorBlack, {
        "data-testid": "MMAnchorBlack",
        secondary: true,
        href: "" + baseUrl + menuItem.item.href,
        theme: theme
      }, menuItem.item.title))), /*#__PURE__*/React.createElement(Divider, null));
    })) : (firstLevelLinks || []).map(function (menuItem, menuKey) {
      return /*#__PURE__*/React.createElement(Row, {
        key: menuKey,
        middle: "sm"
      }, /*#__PURE__*/React.createElement(SCColumnPrimaryMenuItem, {
        sm: 12,
        "data-testid": "MMPrimaryMenuItem"
      }, /*#__PURE__*/React.createElement(SCAnchorBlack, {
        href: "" + baseUrl + menuItem.href,
        theme: theme,
        "data-testid": "MMAnchorBlack"
      }, menuItem.title), /*#__PURE__*/React.createElement(Divider, null)), menuItem.active && (menuItems || []).map(function (subMenuItem, subKey) {
        return /*#__PURE__*/React.createElement(Column, {
          key: subKey,
          sm: 12
        }, /*#__PURE__*/React.createElement(SCColumnSubMenuItem, {
          sm: 12,
          "data-testid": "MMSubmenu"
        }, (subMenuItem.subMenu || []).length > 0 && /*#__PURE__*/React.createElement(SCAnchorBlack, {
          secondary: true,
          active: subKey === activeSubMenuItem,
          onClick: function onClick() {
            return onMenuItemClick(menuKey, subKey);
          },
          theme: theme,
          "data-testid": "MMAnchorBlack"
        }, subMenuItem.item.title, subKey === activeSubMenuItem && /*#__PURE__*/React.createElement(SCMenuIconChevronUp, {
          sm: 24,
          theme: theme
        }), subKey !== activeSubMenuItem && /*#__PURE__*/React.createElement(SCMenuIconChevronDown, {
          sm: 24,
          theme: theme
        })), (subMenuItem.subMenu || []).length === 0 && /*#__PURE__*/React.createElement(SCAnchorBlack, {
          secondary: true,
          href: "" + baseUrl + subMenuItem.item.href,
          theme: theme,
          "data-testid": "MMAnchorBlack"
        }, subMenuItem.item.title)), menuKey === activeMenuItem && subKey === activeSubMenuItem && subMenuItem.subMenu.filter(function (_ref) {
          var subMenu = _ref.subMenu;
          return subMenu;
        }) // Filtering away empty subMenu
        .map(function (subSubMenuItem, subSubKey) {
          return /*#__PURE__*/React.createElement(Fragment, {
            key: subSubKey
          }, subSubMenuItem.subMenu.length > 0 && /*#__PURE__*/React.createElement(SCColumnSubSubMenuItem, {
            sm: 12,
            "data-testid": "MMSubmenu"
          }, /*#__PURE__*/React.createElement(SCAnchorBlack, {
            secondary: true,
            onClick: function onClick() {
              return _this2.onThirdLevelMenuClick(subSubMenuItem);
            },
            theme: theme,
            "data-testid": "MMAnchorBlack"
          }, subSubMenuItem.item.title)), (subSubMenuItem.subMenu || []).length === 0 && /*#__PURE__*/React.createElement(SCColumnSubSubMenuItem, {
            sm: 12,
            "data-testid": "MMSubmenu"
          }, /*#__PURE__*/React.createElement(SCAnchorBlack, {
            secondary: true,
            href: "" + baseUrl + subSubMenuItem.item.href,
            theme: theme,
            "data-testid": "MMAnchorBlack"
          }, subSubMenuItem.item.title)));
        }), /*#__PURE__*/React.createElement(Divider, null));
      }));
    });
  };
  return Menu;
}(React.Component);
var MobileMenu = /*#__PURE__*/function (_React$Component2) {
  _inheritsLoose(MobileMenu, _React$Component2);
  function MobileMenu(props) {
    var _this3;
    _this3 = _React$Component2.call(this, props) || this;
    _this3.closeFourthLevelMenu = function () {
      _this3.setState({
        isFourthLevelMenuOpen: false
      });
    };
    _this3.onClose = function () {
      _this3.closeFourthLevelMenu();
      _this3.props.onClose();
    };
    _this3.onThirdLevelMenuClick = function () {
      _this3.setState({
        isFourthLevelMenuOpen: true
      });
    };
    _this3.state = {
      isFourthLevelMenuOpen: false
    };
    return _this3;
  }
  var _proto2 = MobileMenu.prototype;
  _proto2.render = function render() {
    var _this$props2 = this.props,
      baseUrl = _this$props2.baseUrl,
      menuItems = _this$props2.menuItems,
      isHamburgerMenuOpen = _this$props2.isHamburgerMenuOpen,
      logoLink = _this$props2.logoLink,
      logoAlt = _this$props2.logoAlt,
      logoSrc = _this$props2.logoSrc,
      activeSubMenuItem = _this$props2.activeSubMenuItem,
      activeMenuItem = _this$props2.activeMenuItem,
      onMenuItemClick = _this$props2.onMenuItemClick,
      firstLevelLinks = _this$props2.firstLevelLinks,
      theme = _this$props2.theme;
    var isFourthLevelMenuOpen = this.state.isFourthLevelMenuOpen;

    // Disable body scroll when mobile menu is open
    if (typeof document !== 'undefined' && isHamburgerMenuOpen) {
      document.body.style.overflow = 'hidden';
    }
    if (typeof document !== 'undefined' && !isHamburgerMenuOpen) {
      document.body.removeAttribute('style');
    }
    return /*#__PURE__*/React.createElement(SCHamburgerMenu, {
      isHamburgerMenuOpen: isHamburgerMenuOpen,
      theme: theme
    }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(SCHamburgerHeader, {
      middle: "sm",
      "data-testid": "SCHamburgerHeader"
    }, /*#__PURE__*/React.createElement(StyledIconColumn, null, isFourthLevelMenuOpen && /*#__PURE__*/React.createElement(StyledIconMenuBack, {
      onClick: this.closeFourthLevelMenu
    })), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Logo, {
      baseUrl: baseUrl,
      link: logoLink,
      alt: logoAlt,
      padded: true,
      src: logoSrc
    })), /*#__PURE__*/React.createElement(StyledIconColumn, null, /*#__PURE__*/React.createElement(SCMenuCloseIcon, {
      onClick: this.onClose,
      theme: theme
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, {
      sm: 12
    }, /*#__PURE__*/React.createElement(StyledSearchContainer, null, /*#__PURE__*/React.createElement(Search, {
      isActive: true
    })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, {
      sm: 12
    }, /*#__PURE__*/React.createElement(Menu, {
      baseUrl: baseUrl,
      firstLevelLinks: firstLevelLinks,
      menuItems: menuItems,
      activeSubMenuItem: activeSubMenuItem,
      activeMenuItem: activeMenuItem,
      isFourthLevelMenuOpen: isFourthLevelMenuOpen,
      onMenuItemClick: onMenuItemClick,
      onThirdLevelMenuClick: this.onThirdLevelMenuClick,
      theme: theme
    })))));
  };
  return MobileMenu;
}(React.Component);
export default MobileMenu;